export const asyncForEach = async <T extends Array<any> = any[]>(
	array: T,
	cb: (item: T[number], index: number, array: T) => Promise<any>,
) => {
	for (let index = 0; index < array.length; index++) {
		await cb(array[index], index, array);
	}
};

export default asyncForEach;
